export const pausedCardStyles = {
  body: 'bomdisoft-paused-card-body',
  card: 'bomdisoft-paused-card-card',
  host: 'bomdisoft-paused-card-host',
  pay: 'bomdisoft-paused-card-pay',
  title: 'bomdisoft-paused-card-title',
  who: 'bomdisoft-paused-card-who',
} as const;
